/* unplugin-vue-components disabled */import { render } from "./OccupancyCalendar.vue?vue&type=template&id=6322b0de&ts=true"
import script from "./OccupancyCalendar.vue?vue&type=script&lang=ts"
export * from "./OccupancyCalendar.vue?vue&type=script&lang=ts"

import "./OccupancyCalendar.vue?vue&type=style&index=0&id=6322b0de&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__